import { ResolveResult, APIPromise } from '@/apis/types'
import { Ref, watch } from 'vue'
import { message } from 'ant-design-vue'
import { useRequest } from 'vue-request'

export function wrapPromise<T>(promise: APIPromise<T>) {
  // 错误消息提醒
  promise.alert = () => {
    promise.catch((err) => {
      message.error(err.message)
    })
    return promise
  }
  // loading状态
  promise.loading = () => {
    // showLoading()
    promise.finally(() => {
      // hideLoading()
    })
    return promise
  }
  // key变了则过滤掉
  promise.stopByRef = async (key: Ref) => {
    const preKey = key.value
    const rs = await promise
    const cKey = key.value
    if (preKey !== cKey) {
      return new Promise<T>(() => {})
    }
    return rs
  }
  // 预处理数据
  promise.parse = (parser) => {
    promise.then(parser)
    return promise
  }
  /** 返回一个始终成功的promise, 从数据区分成功/失败 */
  promise.resolve = () => {
    // return useRequest(Promise)
    return new Promise<ResolveResult<T>>((resolve) => {
      promise
        .then((data) => {
          resolve({ error: false, message: '', data })
        })
        .catch((err) => {
          resolve({ error: true, message: err.message, data: null })
        })
    })
  }
  /** 返回一个始终成功的promise */
  promise.resolveDefault = (failValue: any = null) => {
    return new Promise<T>((resolve) => {
      promise
        .then((data) => {
          resolve(data)
        })
        .catch(() => {
          resolve(failValue)
        })
    })
  }

  promise.request = (defaultValue, options) => {
    const rs = useRequest(promise, {
      ...options,
      initialData: defaultValue,
    })
    // 解决初始和失败状态 data 值为 undefined 情况
    if (defaultValue) {
      const unwatch = watch(
        () => rs.loading.value,
        (val) => {
          if (!val && rs.error.value) {
            rs.data.value = defaultValue
            unwatch()
          }
        }
      )
    }
    return rs
  }

  return promise
}
